var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsuariosAtivos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 46C36.598 46 46 36.598 46 25C46 13.402 36.598 4 25 4C13.402 4 4 13.402 4 25C4 36.598 13.402 46 25 46ZM25 48C37.7025 48 48 37.7025 48 25C48 12.2975 37.7025 2 25 2C12.2975 2 2 12.2975 2 25C2 37.7025 12.2975 48 25 48Z",
    fill: "#4B5055"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4852 18.7377C17.4852 14.5876 20.8499 11.2229 25 11.2229C29.1501 11.2229 32.5148 14.5876 32.5148 18.7377C32.5148 22.8878 29.1501 26.2525 25 26.2525C20.8499 26.2525 17.4852 22.8878 17.4852 18.7377ZM25 12.8929C21.7722 12.8929 19.1552 15.5099 19.1552 18.7377C19.1552 21.9655 21.7722 24.5825 25 24.5825C28.2278 24.5825 30.8448 21.9655 30.8448 18.7377C30.8448 15.5099 28.2278 12.8929 25 12.8929Z",
    fill: "#4B5055"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3103 37.9421C13.3103 31.4867 18.5445 26.2524 25 26.2524C31.4554 26.2524 36.6896 31.4867 36.6896 37.9421C36.6896 38.4033 36.3158 38.7771 35.8547 38.7771H14.1453C13.6841 38.7771 13.3103 38.4033 13.3103 37.9421ZM15.0146 37.1071H34.9854C34.561 31.9646 30.2519 27.9224 25 27.9224C19.748 27.9224 15.4389 31.9646 15.0146 37.1071Z",
    fill: "#4B5055"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuariosAtivos);
export default __webpack_public_path__ + "static/media/usuariosAtivos.a47e86e3232c3be5cb54dbc4db817084.svg";
export { ForwardRef as ReactComponent };